<h1 matDialogTitle>メッセージ</h1>
<div mat-dialog-content>{{data?.messages}}</div>
<div mat-dialog-actions>
  <button mat-button [matDialogClose]="true">{{data?.true}}</button>
</div>
